// extracted by mini-css-extract-plugin
export default {"body":"ManufacturerTable_body__YwJIq","icon":"ManufacturerTable_icon__WNzMx","company":"ManufacturerTable_company__OLsmf","notFound":"ManufacturerTable_notFound__3KsP6"};